import { useEffect, useState } from 'react';
import { v1, toResult } from '@/infrastructure/api/v1/client';
import { transformBeMatrix } from './publishingMatrixTransform';
import type { Matrix } from './types';

let cachedMatrix: Matrix | null = null;
let inflight: Promise<Matrix> | null = null;

async function fetchMatrix(): Promise<Matrix> {
  if (cachedMatrix) return cachedMatrix;
  if (inflight) return inflight;
  inflight = (async () => {
    const { data, error } = await toResult(v1.GET('/api/v1/publishing-matrix'));
    if (error) throw new Error(`Publishing matrix fetch failed: ${error.status} ${error.code}`);
    cachedMatrix = transformBeMatrix(data);
    inflight = null;
    return cachedMatrix;
  })();
  return inflight;
}

export function usePublishingMatrix(): Matrix | null {
  const [matrix, setMatrix] = useState<Matrix | null>(cachedMatrix);
  useEffect(() => {
    if (matrix) return;
    let cancelled = false;
    fetchMatrix()
      .then((m) => { if (!cancelled) setMatrix(m); })
      .catch((err) => { console.error('usePublishingMatrix', err); });
    return () => { cancelled = true; };
  }, [matrix]);
  return matrix;
}
